
export default {
    computed: {
       /**
         * 仓库类型
         */
        getWarehouseType() {
            return [
                { value: 0, label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }) },
                { value: 1, label: this.$t('fbb.logistics.time_amazon_address', { defaultValue: '门店' }) },
            ]
        },
        /**
         * 柜型
         */
        getCabinetType() {
            return [
                { value: "20GP", label: this.$t('fbb.logistics.cabinet_type_20gp', { defaultValue: '20尺柜(20GP)' }) },
                { value: "40GP", label: this.$t('fbb.logistics.cabinet_type_40gp', { defaultValue: '40尺柜(40GP)' }) },
                { value: "40HQ", label: this.$t('fbb.logistics.cabinet_type_40hq', { defaultValue: '40尺高柜(40HQ)' }) },
                { value: "45HQ", label: this.$t('fbb.logistics.cabinet_type_45hq', { defaultValue: '45尺高柜(45HQ)' }) },
            ]
        },
        getUnitType() {
            return [
                { value: "box", label: this.$t('fbb.accountmanage.single_xiang', { defaultValue: '箱' }) },
                { value: "cabinet", label: this.$t('fbb.logistics.unit_cabinet', { defaultValue: '柜' }) },
            ]
        },
        getUnit() {
            return [
                { value: "box", label: this.$t('fbb.accountmanage.single_xiang', { defaultValue: '箱' }) },
                { value: "cabinet", label: this.$t('fbb.logistics.unit_cabinet', { defaultValue: '柜' }) },
                { value: "support", label: this.$t('fbb.logistics.unit_support', { defaultValue: 'support' }) },
                { value: "ticket", label: this.$t('fbb.logistics.unit_ticket', { defaultValue: 'ticket' }) },
                { value: "car", label: this.$t('fbb.logistics.unit_car', { defaultValue: '车' }) },
            ]
        },
        getCostType() {
            return [
                { value: "other_cdfee", label: this.$t('', { defaultValue: '舱单费' }) },
                { value: "other_secapp", label: this.$t('', { defaultValue: '进口商安全申报费' }) },
            ]
        },
        getImporterStatus(){
            return [
                { value: 0, label: 'Active' },
                { value: 1, label: 'Inactive' },
            ] 
        }
      
    }
}
